<template>
  <v-select
    :items="statusAtendimento"
    item-text="text"
    item-value="value"
    v-model="statusSelecionados"
    label="Status de Atendimento"
    multiple
    chips
  />
</template>

<script>
export default {
  name: 'FiltroStatusAtendimento',
  data() {
    return {
      statusAtendimento: [
        {
          text: 'Prospecção',
          value: 'prospeccao'
        },
        {
          text: 'Aguardando Pagamento',
          value: 'aguardando'
        },
        {
          text: 'Treinamento',
          value: 'treinamento'
        },
        {
          text: 'Cliente Novo',
          value: 'novo'
        },
        {
          text: 'Experiência',
          value: 'experiencia'
        },
        {
          text: 'Ativo',
          value: 'ativo'
        },
      ],
      statusSelecionados: [
        'prospeccao', 
        'aguardando', 
        'treinamento', 
        'novo', 
        'experiencia', 
        'ativo'
      ]
    }
  },
  mounted() {
    this.emitirStatusSelecionados()
  },
  watch: {
    statusSelecionados() {
      this.emitirStatusSelecionados()
    }
  },
  methods: {
    emitirStatusSelecionados() {
      this.$emit('filtrar-status-atendimento', {
        status_atendimento: this.statusSelecionados
      })
    }
  }
}
</script>
